// @flow strict

import styled from 'styled-components';

import { LegacyTheme } from 'components/_ReactUI_V1';

export const Message = styled.p`
    line-height: 1.3;
`;
